<template>
  <div
    :class="['equipment-request-icon', equipmentStatus]"
    @click="$emit('click')"
  >
    <component :is="statusIcon" class="request-icon w-5" />
  </div>
</template>

<script lang="ts">
import EquipmentDocumentedIcon from "serviceshift-ui/shared/src/assets/equipment-documented.svg";
import EquipmentOptionalIcon from "serviceshift-ui/shared/src/assets/equipment-optional.svg";
import EquipmentRequestedIcon from "serviceshift-ui/shared/src/assets/equipment-requested.svg";

import { EquipmentRequestStatus } from "@/typings/invoice";

export default {
  name: "EquipmentRequestIcon",
  emits: ["click"],
  props: {
    status: {
      type: String as () => EquipmentRequestStatus,
      default: EquipmentRequestStatus.OPTIONAL,
      required: true
    },
    onClick: {
      type: Function
    }
  },
  computed: {
    statusIcon() {
      if (this.equipmentStatus.fulfilled) return EquipmentDocumentedIcon;
      if (this.equipmentStatus.unfulfilled) return EquipmentRequestedIcon;
      return EquipmentOptionalIcon;
    },
    equipmentStatus() {
      return {
        fulfilled: this.status === EquipmentRequestStatus.FULFILLED,
        unfulfilled: this.status === EquipmentRequestStatus.UNFULFILLED,
        optional: ![
          EquipmentRequestStatus.FULFILLED,
          EquipmentRequestStatus.UNFULFILLED
        ].includes(this.status),
        pointer: this.hasClick
      };
    },
    hasClick() {
      return this.$props.onClick;
    }
  }
};
</script>

<style lang="scss" scoped>
.equipment-request-icon {
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pointer {
  cursor: pointer;
}
.fulfilled {
  position: relative;
  top: -2px;
}
</style>
